/**
 * Remove tags HTML e estilos, retornando apenas o texto puro.
 */
export const stripHtml = (htmlString: string): string => {
  if (!htmlString) return ''
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')
  doc.querySelectorAll('style').forEach((tag) => tag.remove())
  doc
    .querySelectorAll('p, li, a, br, h1, h2, h3, h4, h5, h6, div, td')
    .forEach((el) => {
      el.after(' ')
    })
  const text = doc.body.textContent || ''
  return text
    .replace(/\u00A0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
